"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CmsPostCategoryEditor = /** @class */ (function (_super) {
    __extends(CmsPostCategoryEditor, _super);
    function CmsPostCategoryEditor(props) {
        return _super.call(this, props) || this;
    }
    CmsPostCategoryEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            this.setState({
                title: this.props.record.title,
                tag: this.props.record.tag,
                description: this.props.record.description,
                brand_id: this.props.record.brand_id,
                brand_title: this.props.record.brand_title
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Редактирование категории"]);
            });
        }
        else {
            this.setState({
                title: "",
                tag: "",
                description: "",
                brand_id: -1,
                brand_title: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание категории"]);
            });
        }
        this.doReSetRules();
    };
    CmsPostCategoryEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            tag_rules: { isError: false },
            brand_rules: { isError: false },
        });
    };
    CmsPostCategoryEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                title: this.state.title,
                tag: this.state.tag,
                description: this.state.description,
                key: this.props.record.key
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Категория изменена!");
            });
        }
    };
    CmsPostCategoryEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((!this.state.tag) || (this.state.tag.length === 0)) {
            this.setState({ tag_rules: { isError: true, errorMessage: "Поле [tag] не заполнено!" } });
            return false;
        }
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({
                brand_rules: { isError: true, errorMessage: "Поле [бренд] не выбрано!" }
            });
            return false;
        }
        return true;
    };
    CmsPostCategoryEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                title: this.state.title,
                tag: this.state.tag,
                description: this.state.description,
                brand_id: this.state.brand_id
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Категория добавлена!");
            });
        }
    };
    CmsPostCategoryEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    CmsPostCategoryEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить категорию";
        }
        else {
            return "Изменить категорию";
        }
    };
    CmsPostCategoryEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 400 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false },
                    });
                }, items: this.props.brandsList, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Тэг:", placeholder: "Введите тэг" }, value: this.state.tag, onValueChanged: function (newVal) {
                    _this.setState({
                        tag: newVal,
                        tag_rules: { isError: false }
                    });
                }, required: true, rules: this.state.tag_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal,
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return CmsPostCategoryEditor;
}(React.Component));
exports.default = CmsPostCategoryEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_posts/ui/component/CmsPostCategoryEditor.tsx
// module id = 2379
// module chunks = 0